var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{staticClass:"label",class:{'required': _vm.required}},[_vm._v(_vm._s(_vm.label))]),_c('v-select',{attrs:{"outlined":"","dense":"","rules":_vm.rules,"value":_vm.value,"items":_vm.items,"disabled":_vm.disabled},on:{"change":_vm.valueChanged}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }